const industry = [
	{
		"name": "Accommodation and Food Service Activities",
		"value": "Accommodation and Food Service Activities"
	},
	{
		"name": "Administrative and Support Service Activities",
		"value": "Administrative and Support Service Activities"
	},
	{
		"name": "Agriculture and Fishing",
		"value": "Agriculture and Fishing"
	},
	{
		"name": "Arts, Entertainment and Recreation",
		"value": "Arts, Entertainment and Recreation"
	},
	{
		"name": "Construction",
		"value": "Construction"
	},
	{
		"name": "Education",
		"value": "Education"
	},
	{
		"name": "Electricity, Gas, Steam & Air-Conditioning Supply",
		"value": "Electricity, Gas, Steam & Air-Conditioning Supply"
	},
	{
		"name": "Financial and Insurance Activities",
		"value": "Financial and Insurance Activities"
	},
	{
		"name": "Health and Social Services",
		"value": "Health and Social Services"
	},
	{
		"name": "Industry Solutions / Platform Providers",
		"value": "Industry Solutions / Platform Providers"
	},
	{
		"name": "Information and Communications",
		"value": "Information and Communications"
	},
	{
		"name": "Manufacturing",
		"value": "Manufacturing"
	},
	{
		"name": "Mining and Quarrying",
		"value": "Mining and Quarrying"
	},
	{
		"name": "Professional, Scientific and Technical Activities",
		"value": "Professional, Scientific and Technical Activities"
	},
	{
		"name": "Professional Services & Consulting",
		"value": "Professional Services & Consulting"
	},
	{
		"name": "Public Administration and Defence",
		"value": "Public Administration and Defence"
	},
	{
		"name": "Real Estate Activities",
		"value": "Real Estate Activities"
	},
	{
		"name": "Transportation and Storage",
		"value": "Transportation and Storage"
	},
	{
		"name": "Water Supply; Sewerage, Waste Management and Remediation Activities",
		"value": "Water Supply; Sewerage, Waste Management and Remediation Activities"
	},
	{
		"name": "Wholesale and Retail Trade",
		"value": "Wholesale and Retail Trade"
	},
	{
		"name": "Other",
		"value": "Other"
	}
]

export default industry
